const CLAVE = 'cs-dispositivo';

/** Identificador estable del navegador (X-Device-Id): ata el "dispositivo de confianza". */
export function deviceId(): string {
  try {
    let id = localStorage.getItem(CLAVE);
    if (!id) {
      id = crypto.randomUUID();
      localStorage.setItem(CLAVE, id);
    }
    return id;
  } catch {
    return 'sin-almacenamiento';
  }
}
